import React from "react";
import cx from "classnames";

class InputControl extends React.Component {
  static defaultProps = {
    type: "text",
    baseClassName: "si-c-control",
  };

  constructor(props) {
    super(props);

    this.element = null;
  }

  focus = () => {
    // Explicitly focus the text input using the raw DOM API
    this.element.focus();
  };

  select = () => {
    this.element.select();
  };

  blur = () => {
    this.element.blur();
  };

  _setRef = (element) => {
    this.element = element;
  };

  getValue() {
    const { type } = this.props;

    switch (type) {
      case "checkbox":
      case "radio":
        return this.element.value;
      default:
        return this.element.value;
    }
  }

  render() {
    let { type, baseClassName, className, ...otherProps } = this.props;

    let Component = "input";
    switch (type) {
      case "select":
      case "textarea":
        Component = type;
        type = null;
        break;
      default:
        break;
    }

    return (
      <Component
        ref={this._setRef}
        type={type}
        className={cx(baseClassName, className)}
        {...otherProps}
      />
    );
  }
}

export default InputControl;
